<router-outlet></router-outlet>
<app-pwa-update-notification></app-pwa-update-notification>
